import { ApiClient, DynamicComponentTypes, EntityItem } from '../api/content';
import { createStaticQuery, unwrap } from './factory';

export interface SiteModal {
  contentComponents: Array<DynamicComponentTypes>;
  backgroundColor: string;
  enabled: boolean;
}

function getSiteModal() {
  return ApiClient.get<EntityItem<SiteModal>>('/site-modal', {
    params: {
      populate: {
        contentComponents: '*',
        backgroundColor: '*',
      },
    },
  });
}

export const {
  query: SiteModalQuery,
  useQuery: useSiteModalQuery,
  prefetch: prefetchSiteModal,
} = createStaticQuery({
  queryKey: ['site-modal'],
  queryFn: unwrap(getSiteModal),
});
